import { render, staticRenderFns } from "./ReconocimientoCultura.vue?vue&type=template&id=1d234288&scoped=true&"
import script from "./ReconocimientoCultura.vue?vue&type=script&lang=js&"
export * from "./ReconocimientoCultura.vue?vue&type=script&lang=js&"
import style0 from "./ReconocimientoCultura.vue?vue&type=style&index=0&id=1d234288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d234288",
  null
  
)

export default component.exports